import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate} from "react-router-dom";
import { Pagination, EffectFade, Autoplay } from "swiper/modules";


import { useTranslation } from "react-i18next";

import swal from 'sweetalert';

import ttsAudio from "../assets/sound/tts_02.mp3"; // mp3 경로 import
import ttsAudio_en from "../assets/sound/en/2.mp3";
import ttsAudio_jp from "../assets/sound/jp/2.mp3";
import ttsAudio_cn from "../assets/sound/cn/2.mp3";
import ttsAudio_mn from "../assets/sound/mn/2.mp3";

const About = () => {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();

    const [name, SetName] = useState("");

    const audioRef = useRef(null);
    const inputRef = useRef(null);

    const clickNext = () => {
        if (name != "") {
            navigate("/about1_1/" + name);
        } else {
            swal(t("이름을 입력해주세요"), "", "error");
            return;
        }
    };

    // 컴포넌트 마운트 시 자동 재생
    useEffect(() => {
        const audio = audioRef.current;
        if (audio) {
            audio.play().catch(err => {
                console.warn("Autoplay failed:", err);
            });
        }
    }, []);

    // 페이지 진입 시 input 자동 포커스 + 클릭
    useEffect(() => {
        const timer = setTimeout(() => {
            const el = inputRef.current;
            if (!el) return;

            el.focus();

            setTimeout(() => {
                el.click();
            }, 100);
        }, 300);

        return () => clearTimeout(timer);
    }, []);

    var lng = i18n.language;

    return (
        <main className="main-container">
            {lng == "ko" && <audio ref={audioRef} src={ttsAudio} autoPlay />}
            {lng == "en" && <audio ref={audioRef} src={ttsAudio_en} autoPlay />}
            {lng == "jp" && <audio ref={audioRef} src={ttsAudio_jp} autoPlay />}
            {lng == "cn" && <audio ref={audioRef} src={ttsAudio_cn} autoPlay />}
            {lng == "mn" && <audio ref={audioRef} src={ttsAudio_mn} autoPlay />}

            <div className="input-area">
                <div className="step_area">STEP 1</div>
                <div className="title_area">
                    <h1 className="num_title">(1/5)</h1>
                    <h2 className="title">{t("이름을 입력해주세요")}</h2>
                </div>

                <div className="input_section">
                    <input
                        ref={inputRef}
                        type="text"
                        className="text_nor md"
                        id="join_name"
                        value={name}
                        autoComplete="off"
                        onChange={e => {
                            SetName(e.target.value);
                        }}
                    />

                    <div className="start-btn-area">
                        <button className={`Next ${name ? "active" : "disabled"}`} onClick={() => clickNext()}>
                            {t("확인")}
                        </button>
                    </div>
                </div>
            </div>
        </main>
    );
};;

export default About;
